import { TcVm } from '../../core/_infrastructure/types/common';

export class DesautorizadoCamViewModel {
    public Id: number;
    public Campanias: TcVm[];
}

export class AutorizarRecintoPIAEDCamViewModel {
    public Id: number;
    public IdCampania: number;
}
